import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare let localStorage: any;

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Record<string, unknown>) {}

  public getLang() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    return localStorage.getItem('lang');
  }

  public setLang(lang: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.setItem('lang', lang);
  }

  public getFavorites() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    return localStorage.getItem('favorites');
  }

  public setFavorites(productUrls: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    localStorage.setItem('favorites', productUrls);
  }

  public getCart() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    return localStorage.getItem('cart');
  }

  public setToCart(productUrls: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    localStorage.setItem('cart', productUrls);
  }

  public getCartId() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    return localStorage.getItem('cart-id');
  }

  public setCartId(id: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    localStorage.setItem('cart-id', id);
  }

  public getClientData() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const user = localStorage.getItem('client');
    if (!user) {
      return;
    }
    return JSON.parse(user);
  }

  public setClientData(client?: any): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!client) {
      return;
    }

    localStorage.setItem('client', JSON.stringify(client));
  }

  public getAccessToken() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    return localStorage.getItem('x-access-token');
  }

  public setAccessToken(token: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.setItem('x-access-token', token);
  }

  public getRefreshToken() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    return localStorage.getItem('x-refresh-token');
  }

  public setRefreshToken(token: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.setItem('x-refresh-token', token);
  }

  public getWebview(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    return localStorage.getItem('webview') === 'true';
  }

  public setWebview(value: boolean): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.setItem('webview', value ? 'true' : 'false');
  }

  public clear(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.setItem('client', '');
    localStorage.setItem('x-access-token', '');
    localStorage.setItem('x-refresh-token', '');
  }
}
